import { Link, useLang } from '../i18n';
import { CLASSES_LOGIN_URL, CONTACT_EMAIL, COURSE_LOGIN_URL, MEDIA, whatsappUrl } from '../data/siteData';
import { GOOGLE_REVIEWS_URL } from '../data/googleReviews';

function IconFacebook() {
  return <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>;
}
function IconInstagram() {
  return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>;
}
function IconTikTok() {
  return <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.28 6.28 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/></svg>;
}
function IconYouTube() {
  return <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>;
}
export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label={t('Speak English Now, inicio', 'Speak English Now, inici')}><img src={MEDIA.logo} alt="Speak English Now" /></Link>
            <p className="footer-brand-desc">{t('Inglés para usarlo de verdad. Aprende con una ruta clara o con clases adaptadas a ti, de la mano de Caroline Franks y su equipo.', 'Anglès per fer-lo servir de debò. Aprèn amb una ruta clara o amb classes adaptades a tu, de la mà de la Caroline Franks i el seu equip.')}</p>
            <div className="footer-badges">
              <span className="footer-badge">{t('Desde 2006', 'Des del 2006')}</span>
              <span className="footer-badge">FCE · CAE</span>
            </div>
          </div>

          <div className="footer-col">
            <h4>Explora</h4>
            <ul>
              <li><Link to="/">{t('Home', 'Inici')}</Link></li>
              <li><Link to="/curso-online">SEN Pro</Link></li>
              <li><Link to="/clases">{t('Clases', 'Classes')}</Link></li>
              <li><Link to="/nosotros">Sobre SEN</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contacto">{t('Contacto', 'Contacte')}</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>{t('Más recursos', 'Més recursos')}</h4>
            <ul>
              <li><Link to="/libro">{t('El libro de Caroline', 'El llibre de la Caroline')}</Link></li>
              <li><Link to="/curso-online#faq">{t('Preguntas sobre SEN Pro', 'Preguntes sobre SEN Pro')}</Link></li>
              <li><a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer">{t('Reseñas en Google', 'Ressenyes a Google')} ↗</a></li>
              <li><a href={COURSE_LOGIN_URL} target="_blank" rel="noopener noreferrer">{t('Acceso SEN Pro', 'Accés SEN Pro')} ↗</a></li>
              <li><a href={CLASSES_LOGIN_URL} target="_blank" rel="noopener noreferrer">{t('Acceso clases', 'Accés classes')} ↗</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/aviso-legal">{t('Aviso legal', 'Avís legal')}</Link></li>
              <li><Link to="/politica-privacidad">{t('Privacidad', 'Privacitat')}</Link></li>
              <li><Link to="/cookies">Cookies</Link></li>
              <li><Link to="/devolucion">{t('Devoluciones', 'Devolucions')}</Link></li>
              <li><Link to="/terminos">{t('Términos y condiciones', 'Termes i condicions')}</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>{t('Contacto', 'Contacte')}</h4>
            <ul>
              <li><Link to="/contacto">{t('Escríbenos', 'Escriu-nos')}</Link></li>
              <li className="footer-contact-item">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              </li>
            </ul>
            <a
              href={whatsappUrl(t('Hola Caroline, quiero información sobre Speak English Now', 'Hola Caroline, vull informació sobre Speak English Now'))}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-wa-btn"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              {t('Hablar por WhatsApp', 'Parlar per WhatsApp')}
            </a>
            <div className="footer-social">
              <a href="https://www.facebook.com/SpeakEnglishNow21" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="Facebook"><IconFacebook /></a>
              <a href="https://www.instagram.com/speakenglishnow06/" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="Instagram"><IconInstagram /></a>
              <a href="https://www.tiktok.com/@speakenglishnow" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="TikTok"><IconTikTok /></a>
              <a href="https://www.youtube.com/@speakenglishnow06/videos" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="YouTube"><IconYouTube /></a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>{t('© 2006–2026 Speak English Now · Caroline Franks. Todos los derechos reservados.', '© 2006–2026 Speak English Now · Caroline Franks. Tots els drets reservats.')}</span>
          <div className="footer-bottom-links">
            <Link to="/aviso-legal">{t('Aviso Legal', 'Avís Legal')}</Link>
            <span className="footer-sep">|</span>
            <Link to="/terminos">{t('Términos de Uso', 'Termes d\'Ús')}</Link>
            <span className="footer-sep">|</span>
            <Link to="/cookies">Cookies</Link>
            <span className="footer-sep">|</span>
            <Link to="/politica-privacidad">{t('Privacidad', 'Privacitat')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
